import React from "react";
import { motion } from "framer-motion";
// import { AnimatedGradientText } from "../magicui/animated-gradient-text";
// import Image from "next/image";

// type AnimatedToggleProps = {
//     value: "fun" | "professional";
//     onChange: (value: "fun" | "professional") => void;
//     className?: string;
// };

// const gradients = {
//     fun: "linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%)", // hot red/pink
//     professional: "linear-gradient(90deg, #2193b0 0%, #6dd5ed 100%)", // cool blue
// };

export const AnimatedToggle = ({
    value,
    onChange,
    className = "",
    isRunning ,
}) => {
    return (
        <div
            disabled={isRunning}
            className={`shadow-xl border !border-neutral-800 relative w-40 h-11 rounded-full flex items-center px-1  font-dmsans ${className} bg-neutral-950`}
            style={{
                // background: value === "fun" ? gradients.fun : gradients.professional,
                transition: "background 0.4s cubic-bezier(.4,0,.2,1)",
            }}
        >
            {/* Track */}
            <div className="absolute inset-0 rounded-full opacity-30" />
            {/* Labels */}
            <div className="relative z-10 flex w-full justify-between px-[14px]">
                <span
                    className={`!text-[#cfcdc6] font-mod   text-sm transition-colors duration-300 text-black cursor-pointer`}
                    onClick={() => onChange(0)}
                >
                    {/* <AnimatedGradientText>   */}
                        Focus
                        {/* </AnimatedGradientText> */}
                </span>
                <span
                    className={`!text-[#cfcdc6] font-mod  text-sm transition-colors duration-300 text-black cursor-pointer`}
                    onClick={() => onChange(1)}
                >
                    {/* <AnimatedGradientText>  */}
                         Anime
                         {/* </AnimatedGradientText> */}
                </span>
            </div>
            {/* Switch Knob */}
            <motion.div
                className="absolute  left-1 w-20 h-9 rounded-full shadow-lg !z-10 border-2 !border-neutral-800 bg-neutral-950"
                // style={{
                //     background: "black"
                // }}
                layout
                transition={{
                    type: "spring",
                    stiffness: 400,
                    damping: 30,
                }}
                animate={{
                    x: value === 0 ? 0 : 70, // 112px = (w-2*px-padding-knob-width)
                }}
            >
                <div className="flex items-center justify-center h-full">
                    <motion.span
                        className="text-white font-bold text-lg z-100"
                        key={value}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.4 }}
                    >
                        {value === 0 ?
                            <div className="text-2xl">☕️</div>
                            : 
                            <div className="text-2xl">🍜</div>
                            }
                    </motion.span>
                </div>
            </motion.div>
        </div>
    );
};